import type { ValidationResult } from '@idem/tipos/validation-result.type';
import type { ValidationOptions } from '@idem/tipos/validation-options.type';

import { AVISO_FORMATO_DE_NOMBRE_DE_USUARIO } from '@idem/common/mensajes/onboarding';

const FORMATO_PERMITIDO = /^[A-Za-z0-9.]*$/;

export const validarFormatoDeNombreDeUsuario = (
  options: ValidationOptions & ValidationResult,
): ValidationResult => {
  if (!options.code && !FORMATO_PERMITIDO.test(options.value)) {
    return {
      ...options,
      code: 'formato-de-nombre-de-usuario',
      message: () => AVISO_FORMATO_DE_NOMBRE_DE_USUARIO,
    };
  }
  return options;
};
